var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBounce(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.21 6.67C13.97 6.67 14.63 7.52 14.69 8.75H16.87C16.8441 7.8584 16.5165 7.00198 15.9406 6.32078C15.3648 5.63959 14.5748 5.17394 13.7 5V2.81H10.7V5C10.3244 5.07909 9.95881 5.19983 9.61 5.36L11.13 6.8C11.4842 6.71752 11.8463 6.67393 12.21 6.67ZM5.21 3.72L3.81 5.12L7.22 8.52C7.22 10.58 8.76 11.71 11.09 12.4L14.57 15.87C14.2747 16.2057 13.9013 16.4634 13.4827 16.6204C13.064 16.7774 12.6132 16.8288 12.17 16.77C10.17 16.77 9.33 15.86 9.17 14.69H7.08C7.2 16.86 8.83 18.08 10.73 18.48V20.63H13.73V18.5C14.6269 18.3612 15.4679 17.977 16.16 17.39L18.36 19.59L19.76 18.19L5.21 3.72Z",
    fill: "#18406E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBounce);
export default __webpack_public_path__ + "static/media/Bounce.82f4e64f7b408c8d3cd3cccb840fcaa8.svg";
export { ForwardRef as ReactComponent };